var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{attrs:{"autoplay":"","loop":"","preload":"auto","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.webmSource,"type":"video/webm"}}),(_vm.content)?_c('p',[_vm._v(_vm._s(_vm.content))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }